import React from 'react';
import { Box, Typography } from '@mui/material';
import MenuDishImageThumbnail from '../../widgets/MenuDishImageThumbnail';
import ScrollableContentWithHint from '../../widgets/ScrollableContentWithHint';
import {
  PRESERVE_LINE_BREAKS_SX,
  SCROLLABLE_MENU_LIST_SX,
  formatMultilineDisplayText,
} from '../eventFormConstants';

const MenuDishRow = ({ dish }) => {
  const dishDescription = formatMultilineDisplayText(dish.description);

  return (
    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', mb: 1.5 }}>
      <MenuDishImageThumbnail src={dish.imagePreview} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {(dish.dishName || '').trim() ? (
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.5 }}>
            {dish.dishName.trim()}
          </Typography>
        ) : null}
        {dishDescription ? (
          <Typography
            component="div"
            variant="body2"
            color="text.secondary"
            sx={{
              lineHeight: 1.5,
              mt: (dish.dishName || '').trim() ? 0.25 : 0,
              ...PRESERVE_LINE_BREAKS_SX,
            }}
          >
            {dishDescription}
          </Typography>
        ) : null}
        {!(dish.dishName || '').trim() && !dishDescription ? (
          <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
            —
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

const ConfirmationMenuSummary = ({ menuSections }) => {
  const sectionsWithDishes = menuSections
    .map((section) => ({
      ...section,
      dishes: section.dishes.filter((d) => d.dishName || d.description),
    }))
    .filter((section) => section.dishes.length > 0);

  if (sectionsWithDishes.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No menu items added.
      </Typography>
    );
  }

  return (
    <ScrollableContentWithHint sx={SCROLLABLE_MENU_LIST_SX}>
      {sectionsWithDishes.map((section) => (
        <Box key={section.course} sx={{ mb: 2.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
            {section.course}
          </Typography>
          {section.dishes.map((dish, index) => (
            <React.Fragment key={dish.id}>
              {index > 0 && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontStyle: 'italic', my: 0.75, pl: 0.5 }}
                >
                  or
                </Typography>
              )}
              <MenuDishRow dish={dish} />
            </React.Fragment>
          ))}
        </Box>
      ))}
    </ScrollableContentWithHint>
  );
};

export default ConfirmationMenuSummary;
